import { publishOpenHomePage } from '../../events/publish/widgetChannel';
import { openWidget } from './openWidget';

export const openHelpWidgetHomePage = () => {
  publishOpenHomePage();
  openWidget();
};
